import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { JiraQueriesTab } from "./JiraQueriesTab";
import { JiraSettingsTab } from "./JiraSettingsTab";

const TABS = [
  { id: "settings", label: "Settings" },
  { id: "queries", label: "Recent queries" },
] as const;

type TabId = (typeof TABS)[number]["id"];

/** Admin → Jira: proxy settings (allowlist, caps, connection check) and the query log. */
export function AdminJiraPage() {
  const [params] = useSearchParams();
  // `?tab=queries` is where the Slack alert's "Jira log" link lands (alerts/messages.py).
  const [tab, setTab] = useState<TabId>(
    params.get("tab") === "queries" ? "queries" : "settings",
  );
  return (
    <div>
      <h1 className="mb-1 text-2xl font-semibold">Jira</h1>
      <p className="mb-4 text-sm text-slate-500">
        Read-only JQL for artifacts (window.jira) and authors (query_jira),
        forced into the allowlisted projects. Changes apply to the next request
        on every instance.
      </p>
      <div role="tablist" className="mb-4 flex gap-1 border-b border-slate-200">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={tab === t.id}
            onClick={() => setTab(t.id)}
            className={`-mb-px border-b-2 px-3 py-2 text-sm ${
              tab === t.id
                ? "border-slate-900 font-medium text-slate-900"
                : "border-transparent text-slate-500 hover:text-slate-800"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === "settings" ? <JiraSettingsTab /> : <JiraQueriesTab />}
    </div>
  );
}
